import { updateQueryStringParameter } from "../components/GeneralHelpers";

export function updateUrlCountryLanguage({ country, language, isOldPageFormat }) {
  const selectedCountryLowerCase = country.toLowerCase();
  const selectedLanguageLowerCase = language.toLowerCase();

  let redirectUrl = document.location.href;

  if (isOldPageFormat) {
    redirectUrl = updateQueryStringParameter(redirectUrl, "country", selectedCountryLowerCase);
    redirectUrl = updateQueryStringParameter(redirectUrl, "language", selectedLanguageLowerCase);
  } else {
    const shippingRedirectUrl = (selectedCountry, selectedLang) => {
      const urlPath = window.location.pathname.split("/");
      const [_, _country, _lang, ...rest] = urlPath;
      return `${window.location.protocol}//${window.location.hostname}/${selectedCountry}/${selectedLang}/${rest.join(
        "/"
      )}${window.location.search}`;
    };

    redirectUrl = shippingRedirectUrl(selectedCountryLowerCase, selectedLanguageLowerCase);
  }

  return redirectUrl;
}
